import { ButtonColor } from "../../sharedTypes/components";
import "./index.scss";

interface Props {
  color: ButtonColor;
}
const Loader = ({ color }: Props) => (
  <div className="loader">
    <div className="sk-fading-circle">
      <div className={`sk-circle1 sk-circle ${color}`} />
      <div className={`sk-circle2 sk-circle ${color}`} />
      <div className={`sk-circle3 sk-circle ${color}`} />
      <div className={`sk-circle4 sk-circle ${color}`} />
      <div className={`sk-circle5 sk-circle ${color}`} />
      <div className={`sk-circle6 sk-circle ${color}`} />
      <div className={`sk-circle7 sk-circle ${color}`} />
      <div className={`sk-circle8 sk-circle ${color}`} />
      <div className={`sk-circle9 sk-circle ${color}`} />
      <div className={`sk-circle10 sk-circle ${color}`} />
      <div className={`sk-circle11 sk-circle ${color}`} />
      <div className={`sk-circle12 sk-circle ${color}`} />
    </div>
  </div>
);

export default Loader;
